"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectAllFields = exports.Field = void 0;
require("./index.scss");
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var fieldsSelection_1 = require("../../utils/fieldsSelection");
var getFieldName_1 = require("./utils/getFieldName");
var Field = function (props) {
    var _a = React.useState(false), checked = _a[0], setChecked = _a[1];
    React.useEffect(function () {
        var selectedFields = new Set(props.getSelectedFields);
        setChecked(selectedFields.has(props.field));
    }, [props.getSelectedFields]);
    var propsToPass = {
        getSelectedFields: props.getSelectedFields,
        setSelectedFields: props.setSelectedFields
    };
    var onCheck = function (e) {
        e.stopPropagation();
        var handler = e.target.checked
            ? fieldsSelection_1.addToSelectedFields
            : fieldsSelection_1.removeFromSelectedFields;
        handler([props.field], propsToPass);
    };
    return (React.createElement("div", { className: 'report-fields-field' },
        React.createElement(sok_ui_1.Input, { disabled: props.disabled, className: 'checkbox', type: "checkbox", value: checked, onChange: onCheck, label: (0, getFieldName_1.getFieldName)(props.field.fieldName) })));
};
exports.Field = Field;
var SelectAllFields = function (props) {
    var _a = React.useState(false), checked = _a[0], setChecked = _a[1];
    React.useEffect(function () {
        var selectedFields = new Set(props.getSelectedFields);
        setChecked(props.fields.every(function (field) { return selectedFields.has(field); }));
    }, [props.getSelectedFields]);
    var propsToPass = {
        getSelectedFields: props.getSelectedFields,
        setSelectedFields: props.setSelectedFields
    };
    var onCheck = function (e) {
        e.stopPropagation();
        setChecked(e.target.checked);
        var fieldSelectionHandler = e.target.checked
            ? fieldsSelection_1.addToSelectedFields
            : fieldsSelection_1.removeFromSelectedFields;
        fieldSelectionHandler(props.fields, propsToPass);
    };
    return (React.createElement("div", { className: 'report-fields-field' },
        React.createElement(sok_ui_1.Input, { disabled: props.disabled, className: 'checkbox-select-all', type: "checkbox", value: checked, onChange: onCheck, label: (0, getFieldName_1.getFieldName)('SelectAllButton') })));
};
exports.SelectAllFields = SelectAllFields;
